var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-dialog',{attrs:{"visible":true,"before-close":_vm.close,"custom-class":"newDialog","title":_vm.title,"close-on-click-modal":false,"width":"680px"}},[_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn-primary-big btn-in-dialog",on:{"click":_vm.ok}},[_vm._v(" 提交审核 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }